import {
  Box,
  Flex,
  Heading,
  Image,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import placeholderImg from "../../assets/event-placeholder.jpg";
import { useNavigate } from "react-router-dom";
import { WelcomeWeekEvent } from "../../types/welcomeWeekTypes";

type Props = {
  event: WelcomeWeekEvent;
};

const WelcomeCard = ({ event }: Props) => {
  const navigate = useNavigate();
  const bg = useColorModeValue("gray.50", "gray.700");
  const secondaryBg = useColorModeValue("white", "gray.900");
  const hoverColour = useColorModeValue("gray.100", "gray.600");
  const [date, setDate] = useState<Date>();

  useEffect(() => {
    const dateString = event.utcStart.substring(0, 10);
    const [day, month, year] = dateString.split("/").map(Number); // Magic
    const formattedDate = new Date(year, month - 1, day);
    setDate(formattedDate);
  }, []);

  const handleNavigate = () => {
    const eventID = event.id.replace("#", "");
    if (event.location) {
      const latitude = event.location[0].latitude
        ? event.location[0].latitude
        : 0;
      const longitude = event.location[0].longitude
        ? event.location[0].longitude
        : 0;
      navigate(`/welcomeprogramme/event/${eventID}/${latitude}/${longitude}`);
    } else {
      navigate(`/welcomeprogramme/event/${eventID}/0/0`);
    }
  };

  return (
    <Flex
      border="1px solid rgba(0, 0, 0, 0.1)"
      rounded="md"
      overflow="hidden"
      role="group"
      bg={bg}
      cursor="pointer"
      transition=".1s all"
      _hover={{ bg: hoverColour }}
      onClick={handleNavigate}
    >
      <Flex p={3} flex={1} gap={3}>
        <Flex
          direction="column"
          justify="center"
          alignItems="center"
          p={2}
          px={3}
          rounded="md"
          bg={secondaryBg}
          border="1px solid"
          borderColor="blackAlpha.300"
        >
          <Text fontSize="xs" opacity={0.6}>
            {moment(date).format("MMM").toUpperCase()}
          </Text>
          <Text fontSize="3xl" my={-2}>
            {moment(date).format("D")}
          </Text>
          <Text fontSize="xs" opacity={0.6}>
            {moment(date).format("ddd").toUpperCase()}
          </Text>
        </Flex>
        <Flex direction="column" flex={1}>
          <Heading size="sm" mb={1}>
            {event.description}
          </Heading>
          {event.long_description ? (
            <>
              <Text
                wordBreak={"break-word"}
                fontSize="xs"
                dangerouslySetInnerHTML={{
                  __html:
                    event.long_description.length > 75
                      ? `${event.long_description.slice(0, 75)}...`
                      : event.long_description,
                }}
              />
              <Text></Text>
            </>
          ) : null}
          {event.location?.[0].name ? (
            <Text fontSize="sm"> {event.location?.[0].name} </Text>
          ) : null}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default WelcomeCard;
